import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { Shield, FileText, Mail } from 'lucide-react';

export function Footer() {
  const { appConfig } = useApp();
  const currentYear = new Date().getFullYear();
  const supportEmail = appConfig.support_email || 'support@thehistories.me';

  return (
    <footer className="border-t border-border bg-card/50" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-600 to-blue-600 flex items-center justify-center">
                <span className="text-white font-bold text-sm">
                  {appConfig.app_name.charAt(0)}
                </span>
              </div>
              <span className="font-semibold text-foreground">
                {appConfig.app_name}
              </span>
            </div>
            <p className="text-sm text-muted-foreground max-w-xs">
              {appConfig.app_description}
            </p>
          </div>

          {/* Legal Links */}
          <div className="space-y-4">
            <h4 className="font-semibold text-foreground">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
                  data-testid="footer-privacy-link"
                >
                  <Shield className="w-4 h-4" strokeWidth={1.5} />
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-of-service"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
                  data-testid="footer-terms-link"
                >
                  <FileText className="w-4 h-4" strokeWidth={1.5} />
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-semibold text-foreground">Contact</h4>
            <a
              href={`mailto:${supportEmail}`}
              className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
              data-testid="footer-email-link"
            >
              <Mail className="w-4 h-4" strokeWidth={1.5} />
              {supportEmail}
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border">
          <p className="text-center text-sm text-muted-foreground">
            &copy; {currentYear} {appConfig.app_name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
